import axios from 'axios'
import config from '@/config'


interface DecryptResponse {
  decryptedUrl: string;
}

export async function getKbygDecryptUrl(encryptedPaylod:string) : Promise<string> {
  
  const response = await axios.post<DecryptResponse>(`${config.API_URL}/api/decryptURL`, { search:encryptedPaylod })
  return response.data.decryptedUrl;
  
}

